module.exports = __webpack_public_path__ + "media/images/ns-app-battery-icon-60-b9950c9b052927709317b4f6bac71bd3.svg";